export default function About() {
  return (
    <section id="sobre-mi" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[500px] lg:h-[600px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/4ec46dc9a81a1cd20214685c43a59b30.jpg"
                alt="Abogado Profesional"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gold/20 rounded-3xl -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-navy/10 rounded-full mb-6">
              <span className="text-navy text-sm font-semibold uppercase tracking-wide">Sobre Mí</span>
            </div>
            <h2 className="font-serif font-bold text-4xl lg:text-5xl text-gray-900 mb-6 leading-tight">
              Dedicado a la Justicia y la Defensa de sus Derechos
            </h2>
            <p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-6">
              Con una década de experiencia como fiscal en el poder judicial, he dedicado mi carrera profesional a la búsqueda de la justicia y la protección de los derechos fundamentales. Mi trayectoria en el Ministerio Público me ha proporcionado un conocimiento profundo del sistema judicial y una perspectiva única que ahora pongo al servicio de mis clientes.
            </p>
            <p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-8">
              Durante mi tiempo como fiscal, participé en la investigación y resolución de casos complejos, desarrollando habilidades analíticas excepcionales y un compromiso inquebrantable con la ética profesional. Ahora, utilizo esta experiencia para ofrecer una defensa legal sólida y estratégica.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <div className="text-4xl font-bold text-navy mb-2">10+</div>
                <div className="text-sm text-gray-600">Años de Experiencia</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-navy mb-2">500+</div>
                <div className="text-sm text-gray-600">Casos Exitosos</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-navy mb-2">87%</div>
                <div className="text-sm text-gray-600">Tasa de Éxito</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
